import { Tooltip } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Box } from "@mui/system";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { Body, Title, Typography } from "@vds/typography";
import React, { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { deleteItem } from "../../api/SessionServiceManager";
import { ReactComponent as Info } from "../../assets/info.svg";
import {
  fetchDiscoveredCamerasEndPointByCompanion,
  unpairCameraEndPoint,
  unsubscribeCameraCVApplicationEndPoint,
} from "../../configuration";
import CreateWidgetWithComponent from "../../global/CreateWidgetWithComponent";
import axiosInstance from "../../global/axiosInterceptor";
import EditDevice from "../../global/components/Devices/EditDevice";
import CameraInfoTable2 from "../../global/components/Tables/CameraInfoTable2";
import DevicesTable from "../../global/components/Tables/DevicesTable";
import { DEVICE_LIST_TYPE } from "../../global/constants/devices";
import GmtToLocal from "../../global/utility/GmtToLocal";
import {
  Base64ImageDecoder,
  getCVAppData,
  getDeviceMatchingRecordsList,
  getIncidentsData,
  getParentDevice,
  getResourceIdentifierForDevice,
  refreshAllDeviceList,
} from "../../global/utility/Utils";
import { getDeviceType } from "../../global/utility/devicesUtils";
import { hasPermission } from "../../global/utility/permissionUtils";
import {
  getDeviceDetails,
  sortAndSetAlertList,
} from "../../global/utility/tableUtils";
import FloorImageHoc from "../../hoc/FloorImageHoc";
import { ComponentTypes } from "../../model/ComponentTypes";
import {
  fetchCompanionListByCameraRequest,
  modalOpen,
  setShowSensorActivateModal,
  showNotificationBanner,
  updateDeviceFovList,
} from "../../store/actions";
import CameraInfoText from "./CameraInfoText";
import LiveFeed from "./liveFeed";
import { Loader } from "@vds/loaders";
import DiscoverCamera from "../../features/camerOnboarding/discoveredCameraOnboarding";
import { getActiveLicenseSku, LICENSE_SKU_PATTERNS, LICENSE_VALUES } from "../../global/constants/licensesConstants";
import { DELETE_CAMERA_CONSTANTS } from "../../constants/cameraInfoConstants";

export const SearchWithButton = ({
  setSearchDevice,
  setSearchSensor,
  onButtonClick,
  buttonLabel,
  displayListType,
  buttonDisable = false,
}) => {
  const onClick = (e) => {
    if (onButtonClick) {
      onButtonClick();
    }
  };
  return (
    <Box sx={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {displayListType === DEVICE_LIST_TYPE.ALL ? (
          <Icon
            name="plus"
            size="small"
            color="#000000"
            onClick={(e) => alert("Button clicked")}
          />
        ) : (
          <Button
            size="small"
            disabled={buttonDisable || false}
            use="primary"
            onClick={onClick}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
    </Box>
  );
};

const CameraInfo = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  let navigate = useNavigate();
  const { showSensorActivatedModal, cvAppDataFetch, cameraList } = useSelector(
    (state) => state.deviceReducer
  );

  const dispatch = useDispatch();
  const { state: locState, search } = useLocation();
  const urlCameraId = new URLSearchParams(search).get("cameraId");
  const cameraFromStore = useMemo(
    () => cameraList?.find((c) => c.id === urlCameraId) ?? null,
    [cameraList, urlCameraId]
  );
  const state = locState ?? (cameraFromStore ? { data: cameraFromStore } : null);

  const camDetails = state ? state.data : "";
  const [showEditDevice, setShowEditDevice] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData1, setTableData1] = useState([]);
  const [associateCvAppLoading, setAssociateCvAppLoading] = useState(false);
  const [loadAssociateCamera, setLoadAssociatedCamera] = useState(false);
  const [tableRow, setTableRow] = useState([]);
  const [displayListType, setDisplayListType] = useState(state || 0);
  const [refreshDeviceTable, setRefreshDeviceTable] = useState(false);
  const [fetchIncidents, setFetchIncidents] = useState(false);
  const [evidences, setEvidences] = useState([]);
  const [discoveryCameraLoading, setDiscoveryCameraLoading] = useState(false);
  const [cvAppSelected, setCvAppSelected] = useState("");
  const [items, setItems] = useState([]);
  const [discoverCameraData, setDiscoverCameraData] = useState([]);
  const [cameraDevices, setCameraDevices] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalIncidents, setTotalIncidents] = useState(0);
  const [deviceTagsList, setDeviceTagsList] = useState([]);
  const [selectedTable, setSelectedTable] = useState();
  const deviceList = JSON.parse(sessionStorage.getItem("deviceList"));

  const [incidentList, setIncidentList] = useState([]);
  const [cameraCVAppList, setCameraCVAppList] = useState([]);
  const [channelInfo, updateChannelInfo] = useState({ name: "" });
  const [isLiveChannelEdit, setIsLiveChannelEdit] = useState(false);
  const stateData = state?.data;

  const [deviceInfo, setdeviceInfo] = useState(state?.data);
  const [deviceCvApps, setDeviceCvApps] = useState([]);

  const [floorImage, setFloorImage] = useState();
  const [imageLoading, setImageLoading] = useState(false);
  const [savedSubscribedCvApps, setSavedSubscribedCvApps] = useState({});

  const commonProperties = state?.data?.customdata?.location;
  const subArea =
    commonProperties?.subarea?.name === "NA"
      ? ""
      : commonProperties?.subarea?.name + ",";
  const area = commonProperties?.area?.name;
  const floorName = commonProperties?.floor?.name;
  const siteName = commonProperties?.site?.name;
  const floorTitle = subArea + area + "," + floorName;
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const floors = sitesTagList?.floors;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteCameraLoading, setIsDeleteCameraLoading] = useState(false);
  const [liveFeedPermitted, setLiveFeedPermitted] = useState(false);
  const companionReducerList = useSelector(
    (state) => state?.deviceReducer?.companionDeviceList
  );
  const [liveFeedList, setLiveFeedList] = useState([]);
  const [defaultLicenseType, setDefaultLicenseType] = useState(null);

  const getFloor = (tagList) => {
    const floor = tagList
      .map((id) => floors.find((f) => f.id === id))
      .find((f) => f);
    return floor ? floor : null;
  };
  const cameraType =
    state?.data?.fovs && state?.data?.fovs[0].customdata?.mode === "manual"
      ? "Manual"
      : "Auto";
  const handleDeleteCamera = async (cameraItem) => {
    setIsDeleteCameraLoading(true);

    const companion = companionReducerList.find(
      (companion) => companion.id == cameraItem.parentdeviceid
    );
    let companionidentifier = {};
    companionidentifier[companion.refidtype] = companion?.refid;
    let cameraidentifier = {};
    cameraidentifier[cameraItem.refidtype] = cameraItem?.refid;
    const body = {
      accountname: activeSession.accountId,
      companionidentifier: companionidentifier,
      cameraidentifier: cameraidentifier,
    };
    const response = await deleteItem(unpairCameraEndPoint(), body);
    if (response.status === 200) {
      const notificationInfo = {
        type: "Delete Camera",
        priority: "success",
        data: { subTitle: `Camera unpaired successfully` },
        showNotification: true,
      };
      dispatch(showNotificationBanner(notificationInfo));
      navigate("/devices");
    } else {
      const error = response.data;
      const message =
        response?.status === 500
          ? `${error?.error_description} `
          : "Something went wrong, Please try again later.";
      const notificationInfo = {
        type: "Delete Camera",
        priority: "critical",
        data: { subTitle: `Failed to unpair camera - '${message}' ` },
        showNotification: true,
      };
      dispatch(showNotificationBanner(notificationInfo));
      console.error("Failed to unpair camera");
    }
    setIsDeleteCameraLoading(false);
    handleCloseModal();
  };

  useEffect(() => {
    if (showEditDevice === false) {
      updateChannelInfo({ name: "" });
      setIsLiveChannelEdit(false);
      setdeviceInfo(state?.data);
    }
  }, [showEditDevice]);

  const callIncidentsApi = async () => {
    try {
      setIncidentList([]);
      setTableLoading(true);
      const fetchIncidentRequestBody = {
        accountname: activeSession.accountId,
        resourceidentifier: {
          sourceid: state?.data?.id,
        },
        filter: {
          limitnumber: itemsPerPage,
          page: "",
          pagenumber: selectedPage,
        },
      };
      const fetchIncidentsRsp = await getIncidentsData(
        fetchIncidentRequestBody
      );
      if (fetchIncidentsRsp.error) {
        setTableLoading(false);
      }
      const status = fetchIncidentsRsp.status;
      setTotalIncidents(parseInt(fetchIncidentsRsp.headers.XTotalCount));

      if (!fetchIncidentsRsp.error) {
        let incidentList = fetchIncidentsRsp.res;
        const getStreamName = (evidences) => {
          let streamName = "";
          if (evidences.length > 0) {
            deviceList.map((device) => {
              const fovId = device.id;
              const evedienceFovId =
                evidences.find((e) => e.fovId === fovId)?.fovId || "";
              if (fovId === evedienceFovId) {
                streamName = device.name;
              }
            });
          }
          return streamName;
        };

        for (let i = 0; i < incidentList.length; i++) {
          let deviceName = getDeviceDetails(
            deviceList,
            incidentList[i].deviceid
          );
          let alertDetails = {};
          alertDetails.devicename = deviceName?.name;
          alertDetails.device = deviceName;
          incidentList[i].createdAt = GmtToLocal(incidentList[i].createdAt);
          incidentList[i].streamName = getStreamName(incidentList[i].evidences);
          incidentList[i] = { ...incidentList[i], ...alertDetails };
        }
        const evidenceList = incidentList.filter(
          (item) =>
            item?.evidences &&
            item.evidences.length > 0 &&
            item.evidences.some(
              (evidence) => evidence.sourceId === state?.data?.refid
            )
        );
        setEvidences(evidenceList);
        setIncidentList([...sortAndSetAlertList(incidentList)]);
        setTableLoading(false);
      }
      setFetchIncidents(true);
      setTableLoading(false);
    } catch (e) {
      setTableLoading(false);
      console.log(e);
    }
  };

  const handlePageClick = (page) => {
    setSelectedPage(page);
    setFetchIncidents(false);
    setTableLoading(true);
  };

  useEffect(() => {
    if (!fetchIncidents) {
      var req = {
        accountname: sessionStorage.getItem("accountId"),
        filter: {
          limitnumber: itemsPerPage,
          page: "",
          pagenumber: selectedPage,
        },
      };
      callIncidentsApi(req);
    }
  }, [fetchIncidents]);

  useEffect(() => {
    thumbnailItems();
  }, [evidences]);

  const thumbnailItems = async () => {
    const itemsList = [];
    if (evidences.length > 0) {
      await Promise.all(
        evidences.map(async (e) => {
          await Promise.all(
            e.evidences.map(async (f) => {
              const { createdAt, id, mediaType, thumbnail } = f;
              const date = GmtToLocal(e.createdAt);
              if (mediaType === "video") {
                const i = {
                  title: date,
                  cardTitle: e.description,
                  evidenceDetail: f,
                  id: id,
                  media: {
                    type: "IMAGE",
                    source: {
                      url: Base64ImageDecoder(thumbnail),
                    },
                  },
                };

                itemsList.push(i);
              }
            })
          );
        })
      );
      setItems([...itemsList]);
    }
  };

  const editButtonOnClick = (show, name, location) => {
    if (name != "") state.data.name = name;
    if (location != "") updateCustomData(location);
    setShowEditDevice(show);
    setdeviceInfo(state?.data);
  };

  useEffect(() => {
    setDeviceTagsList(state?.data?.tagids || []);
  }, [state]);

  useEffect(() => {
    if (displayListType === DEVICE_LIST_TYPE.CAMERA) {
      dispatch(setShowSensorActivateModal({ showSensorActivatedModal: false }));
      loadDiscoveredCameraData();
      loadDeviceListTableData();
    }
  }, [displayListType]);

  const loadDiscoveredCameraData = async () => {
    try {
      const deviceList = JSON.parse(
        sessionStorage.getItem("companionDevicesList")
      );

      setDiscoverCameraData([]);
      setDiscoveryCameraLoading(true);
      const tableData = [];
      if (deviceList?.length) {
        await Promise.all(
          deviceList?.map(async (item) => {
            const resourceidentifier = getResourceIdentifierForDevice(item);
            const response = await axiosInstance.post(
              fetchDiscoveredCamerasEndPointByCompanion(),
              {
                accountname: activeSession.accountId,
                resourceidentifier: resourceidentifier,
                forcediscovery: true,
              }
            );

            const resData = response.data;
            const status = response.status;

            if (resData?.length) {
              const filterResult = resData?.filter((res) => {
                return (
                  tableData?.findIndex((disc) => disc?.refid === res?.refid) < 0
                );
              });
              tableData.push(...filterResult);
            }
          })
        );
        setDiscoverCameraData(tableData);
        setDiscoveryCameraLoading(false);
      }
    } catch (e) {
      console.log(e);
      setDiscoveryCameraLoading(false);
    }
  };

  const loadDeviceListTableData = async () => {
    setTableRow([]);
    try {
      await refreshAllDeviceList(activeSession);
      setRefreshDeviceTable(true);
    } catch (err) {
      setTableLoading(false);
    }
  };

  const updateCustomData = (location) => {
    if (state.data.hasOwnProperty("customdata")) {
      state.data.customdata.location = location;
    } else {
      var obj = {};
      obj["customdata"] = { location: location };
      state.data = Object.assign(state.data, obj);
    }
  };

  const accountID = activeSession.accountId ? activeSession.accountId : "";
  const isTestAccount = accountID === "Shweta home lab" ? true : false;

  let sensorType = getDeviceType(state);
  let parentDevice = getParentDevice(state?.data);
  let parentDeviceLocation =
    parentDevice.fields && parentDevice.fields && parentDevice.fields.location
      ? parentDevice.fields.location
      : null;

  let fieldTestArr = state?.data
    ? state.data.fields
      ? Object.keys(state.data.fields)
      : null
    : null;
  let newFieldArr = getFieldArr(fieldTestArr);

  function getFieldArr(fields) {
    let initFieldArr = [];
    if (fields) {
      fields.map((field) => {
        if (
          field !== "OUT1" &&
          field !== "OUT2" &&
          field !== "DeviceStatus" &&
          field !== "SNRLastUplink"
        ) {
          initFieldArr.push(field);
        }
      });
    } else {
      return "No properties found";
    }

    return initFieldArr;
  }

  const handleDelete = async (cvAppItem) => {
    try {
      setAssociateCvAppLoading(true);
      const response = await axiosInstance.post(
        unsubscribeCameraCVApplicationEndPoint(),
        {
          accountname: activeSession.accountId,
          resourceidentifier: {
            id: cvAppItem.id,
            deviceid: tableData1[selectedTable].id,
          },
        }
      );
      const res = response.data;
      const status = response.status;
      if (response.status == 200) {
        let resarray = [res];
        sessionStorage.removeItem("cvAppsData", JSON.stringify(resarray));
        const oldDeviceCvApps = [...deviceCvApps];
        if (res?.deviceid) {
          const index = oldDeviceCvApps.findIndex(
            (d) => d.deviceid === res.deviceid
          );
          if (index !== -1) {
            oldDeviceCvApps.splice(index, 1);
          } else {
            oldDeviceCvApps.push(res);
          }
        }
        setDeviceCvApps([oldDeviceCvApps]);
      }

      if (res?.message) {
        setLoadAssociatedCamera((prev) => !prev);
      }
      setAssociateCvAppLoading(false);
    } catch (e) {
      setAssociateCvAppLoading(false);
      console.log(e);
    }
  };

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const handleEditCameraClick = () => {
    // const camDetails = state ? state.data : "";
    if (!hasPermission("Cameras", "Edit")) {
      showPermissionsBanner();
    } else {
      dispatch(
        modalOpen({
          isPairing: false,
          camDetails: camDetails,
          onBoradType: cameraType,
          editFlow: true,
        })
      );
    }
  };

  const handleDeleteCameraClick = () => {
    if (!hasPermission("Cameras", "Delete")) {
      showPermissionsBanner();
    } else {
      setSavedSubscribedCvApps({});
      setIsDeleteModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
  };

  const storeSubscribedCvAppsData = (data) => {
    setSavedSubscribedCvApps(data);
  };

  const handleFetchSubscribedCvAppsError = () => {
    const notificationInfo = {
      type: DELETE_CAMERA_CONSTANTS.DELETE_CAMERA,
      priority: "critical",
      data: { subTitle: DELETE_CAMERA_CONSTANTS.DELETE_CAMERA_MSG},
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
    handleCloseModal();
  };

  useEffect(() => {
    async function fetchMyAPI() {
      const response = await getDeviceMatchingRecordsList(
        stateData?.id,
        activeSession,
        dispatch,
        updateDeviceFovList
      );
      setLiveFeedList(response);
      if (response?.[0]?.licenses) {
        setDefaultLicenseType(getActiveLicenseSku(response[0].licenses));
      } else {
        setDefaultLicenseType(LICENSE_VALUES.NO_LICENSE);
      }
    }
    if (channelInfo?.name === "" && stateData?.id) {
      fetchMyAPI();
    }
  }, []);

  useEffect(() => {
    if (hasPermission("Live video feed", "View")) {
      setLiveFeedPermitted(true);
    }
  }, []);

  const CachedFloorImage = FloorImageHoc(
    CreateWidgetWithComponent,
    state?.data?.refid,
    false,
    state?.data?.customdata?.location?.floor?.tag,
    floorImage
  );

  return (
    <>
      <DiscoverCamera onClose={() => dispatch(modalOpen({}))} />

      <Breadcrumbs surface="light">
        <BreadcrumbItem>
          <Link
            data-testid="newCameraInfo_devicesLink"
            to="/devices"
            state={{ tabName: "Camera" }}
            className="breadcrums-item_link"
          >
            Cameras
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>Camera Details</BreadcrumbItem>
      </Breadcrumbs>

      <div
        className="sasp_vz-nhg-eds-font"
        style={{
          fontWeight: "300",
          fontSize: "32px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "3px",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <div>{deviceInfo?.name}</div>
            <Tooltip
              placement="top"
              title={
                <div
                  style={{
                    width: "auto",
                    padding: "5px",
                    color: "black",
                    fontSize: "12px",
                  }}
                >
                  <Body viewport="desktop" size="small" bold={true}>
                    {" "}
                    Camera Id{" "}
                  </Body>
                  <Body size="small" viewport="desktop">
                    {deviceInfo?.id}
                  </Body>
                </div>
              }
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    border: "1px solid black",
                    "& .MuiTooltip-arrow": {
                      backgroundColor: "white",
                    },
                  },
                },
              }}
            >
              <sup>
                {" "}
                <Info />{" "}
              </sup>
            </Tooltip>
          </div>
          <CameraInfoText cameraDetails={state?.data} />
        </div>

        <div
          style={{
            display: "flex",
            gap: "1rem",
          }}
        >
          <Button
            size="large"
            disabled={false}
            use="primary"
            onClick={handleEditCameraClick}
          >
            Edit
          </Button>
          <Button
            size="large"
            disabled={false}
            use="secondary"
            data-testid="cameraInfo_deleteButton"
            onClick={handleDeleteCameraClick}
          >
            Delete
          </Button>
        </div>
      </div>

      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        opened={showEditDevice}
        disableOutsideClick={true}
        hideCloseButton={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            onClick={() => {
              setShowEditDevice(false);
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        <EditDevice
          deviceInfo={deviceInfo}
          setShowEditDevice={editButtonOnClick}
          deviceTagsList={deviceTagsList}
          setDeviceTagsList={setDeviceTagsList}
          channelInfo={channelInfo}
          isLiveChannelEdit={isLiveChannelEdit}
        />
      </Modal>

      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "560px",
        }}
        opened={isDeleteModalOpen}
        disableOutsideClick={true}
        hideCloseButton={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            data-testid="newCameraInfo_deleteCameraModalTopCancelButton"
            onClick={() => {
              setIsDeleteModalOpen(false);
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        {isDeleteCameraLoading ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <>
            <ModalTitle>
              <div style={{ marginBottom: "30px" }}>
                <Title
                  size="large"
                  use="primary"
                  viewport="desktop"
                  bold="True"
                >
                  {DELETE_CAMERA_CONSTANTS.DELETE_CAMERA}
                </Title>
              </div>
              <Notification
                type="warning"
                hideCloseButton={false}
                title="Warning"
                subtitle={DELETE_CAMERA_CONSTANTS.DELETE_CAMERA_WARNING_MSG}
              />
            </ModalTitle>
            <ModalBody>
              <Body size="large">
                {savedSubscribedCvApps?.names === undefined ? (
                    <div className="flex-center-container">                  
                    <Loader active={true} fullscreen={false} />
                  </div>
                ) : (
                  <>
                    {savedSubscribedCvApps?.names?.length > 0 ? (
                      <>
                        <p>
                          {DELETE_CAMERA_CONSTANTS.CAMERA_CVAPP_MSG}                         
                        </p>
                        <b>Apps</b>
                        <ul>
                          {savedSubscribedCvApps?.names?.map((item, idx) => (
                            <li key={idx} style={{ listStyleType: "disc" }}>{item}</li>
                          ))}
                        </ul>
                      </>
                    ) : (
                        <p>{DELETE_CAMERA_CONSTANTS.CONFIRM_DELETE}</p>
                    )}
                  </>
                )}
              </Body>
              <div
                style={{
                  display: "flex",
                  paddingTop: "35px",
                  gap: "12px",
                  overflow: "hidden",
                }}
              >
                <Button
                  size="large"
                  disabled={
                    isDeleteCameraLoading ||
                    savedSubscribedCvApps?.names === undefined ||
                    savedSubscribedCvApps?.names?.length > 0
                  }
                  width="100%"
                  use="primary"
                  data-testid="newCameraInfo_deletePrimaryCameraButton"
                  onClick={() => handleDeleteCamera(camDetails)}
                >
                  {isDeleteCameraLoading ? "deleting..." : "Yes, delete"}
                </Button>
                <Button
                  size="large"
                  disabled={false}
                  width="100%"
                  use="secondary"
                  data-testid="newCameraInfo_deleteSecondaryCameraButton"
                  onClick={() => handleCloseModal()}
                >
                  No, cancel
                </Button>
              </div>
            </ModalBody>
          </>
        )}
      </Modal>

      <Grid2
        container
        marginTop={3}
        marginBottom={3}
        spacing={1}
        columns={{ xs: 18 }}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch",
        }}
      >
        <Grid2
          xs={18}
          lg={9}
          direction="row"
          style={{
            backgroundColor: "#F6F6F6",
            borderRadius: "8px",
            paddingBottom: "33px",
            height: "100%",
          }}
        >
          {liveFeedPermitted && <LiveFeed liveFeedList={liveFeedList} />}
          {!liveFeedPermitted && (
            <Box
              sx={{
                backgroundColor: "#F6F6F6",
                borderRadius: "8px",
                width: "80%",
                height: "455px",
                padding: "10px",
                display: "flex",
                justifySelf: "center",
                alignItems: "center",
              }}
            >
              <div>
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: "20px",
                    marginBottom: "1rem",
                  }}
                >
                  Live feed is not available.
                </Typography>
                <Typography style={{ fontWeight: 400, fontSize: "16px" }}>
                  You do not have the required access to watch live feed. Please
                  view your permissions on the users page or talk to your system
                  administrator.
                </Typography>
              </div>
            </Box>
          )}
        </Grid2>

        <Grid2
          xs={18}
          lg={9}
          direction="row"
          style={{
            overflow: "hidden",
            // margin: "auto",
            padding: "0 0 0 15px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="device_grid_2"
        >
          <div
            style={{
              backgroundColor: "#F6F6F6",
              borderRadius: "10px",
              padding: "10px",
              // marginLeft: "15px",
              height: "100%",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <span style={{ fontWeight: "bold" }}>{floorTitle}</span>
            <br />
            <span>{siteName}</span>

            <CachedFloorImage
              title=""
              inputHeight="100%"
              comp={ComponentTypes.floorPlan}
            />
          </div>
        </Grid2>
      </Grid2>

      <div style={{ backgroundColor: "#F6F6F6" }}>
        <div style={{ padding: "20px 0px 10px 10px" }}>
          <Title size="medium" viewport="desktop">
            Stream details
          </Title>
        </div>
        <CameraInfoTable2
          cameraDetails={state?.data}
          setTableData1={setTableData1}
          cameraCVAppList={cameraCVAppList}
          handleDelete={handleDelete}
          liveFeedList={liveFeedList}
          defaultLicenseType={defaultLicenseType}
          storeSubscribedCvApps={storeSubscribedCvAppsData}
          isDeleteModalOpen={isDeleteModalOpen}
          setLiveFeedList={setLiveFeedList}
          onFetchSubscribedCvAppsError={handleFetchSubscribedCvAppsError}
        />
      </div>

      <div style={{ backgroundColor: "#F6F6F6" }}>
        <div style={{ padding: "20px 0px 10px 10px" }}>
          <Title size="medium" viewport="desktop">
            Camera Events
          </Title>
        </div>
        <div>
          <DevicesTable
            pageName="cameraEvents"
            incidentList={incidentList}
            state={state}
            cameraId={state?.data?.refid}
            handlePageClick={handlePageClick}
            totalIncidentCount={totalIncidents}
            itemsPerPage={itemsPerPage}
            tableLoading={tableLoading}
          />
        </div>
      </div>
    </>
  );
};

export default CameraInfo;
